// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from 'E:/web/molong/reset/frontend/gatherstar-admin/apps/dsp-manager/src/models/list';
import model_2 from 'E:/web/molong/reset/frontend/gatherstar-admin/apps/dsp-manager/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'list', model: model_1 },
model_2: { namespace: '@@initialState', model: model_2 },
} as const
